import type { EmailFileAttachment } from '../providers/AIContext';
import { userTempInventoryState } from './userTempInventoryState';
import { uploadTempAttachment } from './uploadTempAttachment';
import { removeFromUserTempInventory } from './removeFromUserTempInventory';
import { writeParsedEmailSidecar, type ParsedEmailSidecar } from './writeParsedEmailSidecar';

interface UploadEmailInput {
    content: Uint8Array;
    filename: string;
    contentType: string;
    sizeBytes: number;
    parsed: ParsedEmailSidecar;
}

export async function uploadEmailToUserTempInventory(
    input: UploadEmailInput,
): Promise<EmailFileAttachment> {
    const userId = userTempInventoryState.userId;
    if (!userId) throw new Error('userTempInventory: not connected');
    const { fileId, fileFolder, originalPath } = await uploadTempAttachment({
        content: input.content,
        filename: input.filename,
        contentType: input.contentType,
        userId,
    });
    try {
        await writeParsedEmailSidecar(fileFolder, input.parsed);
    } catch (sidecarError) {
        await removeFromUserTempInventory(fileFolder);
        throw sidecarError;
    }
    const att: EmailFileAttachment = {
        kind: 'email',
        filename: input.filename,
        fileId,
        fileFolder,
        originalPath,
        contentType: input.contentType,
        sizeBytes: input.sizeBytes,
        subject: input.parsed.subject,
        from: input.parsed.from,
        body: input.parsed.body,
    };
    const exists = userTempInventoryState.files.some((f) => f.fileFolder === fileFolder);
    if (!exists) {
        userTempInventoryState.files = [att, ...userTempInventoryState.files];
    }
    return att;
}
